import axios from "../http";
let module = "/dict";

function dictList(params){
    return axios.get(module, {params:params});
}

function dictAdd(params){
    return axios.post(module, params);
}

function dictEdit(params){
    return axios.put(module, params);
}

export default {
    dictList,dictAdd,dictEdit
}